'use client';

import React from 'react';
import Script from 'next/script';
import useDisableTrackingsExceptGA from 'tracking/src/disableTrackings/useDisableTrackingsExceptGA';
import WarmlyScript from 'tracking/src/WarmlyScript';
import LeadfeederScript from 'tracking/src/LeadfeederScript';
import CommonRoomScript from 'tracking/src/CommonRoomScript';
import MountainTrackingScript from 'tracking/src/MountainTrackingScript';

export default function Scripts() {
  const { disableAllExceptGoogleAnalytics } = useDisableTrackingsExceptGA();
  if (disableAllExceptGoogleAnalytics) return null;
  return (
    <>
      {/* Anti-flicker snippet */}
      <Script id="anti-flicker-snippet" strategy="afterInteractive">
        {`
        (function(a, s, y, n, c, h, i, d, e) {
          s.className += ' ' + y;
          h.start = 1 * new Date;
          h.end = i = function() {
            s.className = s.className.replace(RegExp(' ?' + y), '')
          };
          (a[n] = a[n] || []).hide = h;
          setTimeout(function() {
            i();
            h.end = null
          }, c);
          h.timeout = c;
        })(window, document.documentElement, 'async-hide', 'dataLayer', 1500, {
          'GTM-M79R6L5': true
        });
      `}
      </Script>
      {/* Google Tag Manager */}
      <Script id="google-tag-manager" strategy="afterInteractive">
        {`
        (function(w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
          });
          var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-M79R6L5');
      `}
      </Script>

      {process.env.NEXT_PUBLIC_DEANONYMIZE_ENABLE === 'true' && <WarmlyScript />}

      {process.env.NEXT_PUBLIC_DEANONYMIZE_ENABLE === 'true' && <LeadfeederScript />}

      <CommonRoomScript />

      <MountainTrackingScript />

      <Script
        data-cfasync="false"
        src="https://analytics.ahrefs.com/analytics.js"
        strategy="afterInteractive"
        data-key="Vkqqs0SjCCiLPM17rCu4Hw"
        async
      />

      <Script id="facebook-pixel" strategy="afterInteractive">
        {`!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
document,'script','https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '291607657972215'); // Insert your pixel ID here.
fbq('track', 'PageView');`}
      </Script>

      <noscript>
        <img
          alt=""
          height="1"
          width="1"
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=291607657972215&ev=PageView&noscript=1"
        />
      </noscript>
    </>
  );
}
